export const LANDING_PATHS = {
  main: "/",
  mainPreview: "/lp/main-landing",
  partner: "/lp/partner-landing",
  roofing: "/lp/roofing-landing",
  realEstate: "/lp/real-estate-landing",
  interceptProtocol: "/lp/intercept-protocol",
};

export const appLoginPath = (returnPath = "/dashboard") => {
  const encoded = encodeURIComponent(returnPath);
  return `/login?returnTo=${encoded}`;
};
